// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const { CircleButton } = require('client-v2/common/components/buttons')
const Portal = require('client-v2/common/components/portal')
const Icon = require('client-v2/common/containers/icons/component')
const SearchForm = require('client-v2/common/containers/search-form/component-smart')
const {
  interestProfilePostsHref
} = require('client-v2/common/models/interest/actions')
const {
  userProfilePostsHref,
  sharedHref
} = require('client-v2/common/models/user/actions')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppSidebar')

function AppSidebar({
  className,
  currentHref,
  isSearchVisible,
  user,
  onAddClick,
  onLinkClick,
  onSearchClick,
  onSearchDismiss
}) {
  const inboxCount = user.sharesUnreadCount
  // Hooks
  const handleSearchDismiss = React.useCallback(
    event => {
      // Ignore events that happen on child nodes
      if (event.target === event.currentTarget) {
        onSearchDismiss()
      }
    },
    [ onSearchDismiss ]
  )
  const AppSidebarLink = React.useCallback(
    function AppSidebarLink({
      children,
      href,
      onClick = onLinkClick
    }) {
      return (
        tag('a', {
          className: bem.element('link', {
            selected: href === currentHref
          }),
          href,
          onClick
        },
          children
        )
      )
    },
    [ currentHref, onLinkClick ]
  )
  // Render
  return (
    tag('nav', {
      'aria-label': 'Main',
      className: classNames(
        className,
        bem.block()
      )
    },
      tag('div', {
        className: bem.element('top')
      },
        tag('a', {
          href: '/',
          title: 'Mix Home',
          onClick: onLinkClick
        },
          tag(Icon, {
            className: bem.element('logomark'),
            id: 'mix-logomark'
          })
        ),
        tag('div', {
          className: bem.element('top-spacer')
        }),
        tag(CircleButton, {
          className: bem.element('search'),
          onClick: isSearchVisible ? onSearchDismiss : onSearchClick
        },
          tag(Icon, { id: 'search' })
        ),
        tag(CircleButton, {
          className: bem.element('add'),
          onClick: onAddClick
        },
          tag(Icon, { id: 'plus' })
        )
      ),
      isSearchVisible && Portal.toModalRoot(
        tag('div', {
          className: bem.element('search-modal'),
          onClick: handleSearchDismiss
        },
          tag(SearchForm, {
            className: bem.element('search-form')
          })
        )
      ),
      tag(AppSidebarLink, {
        href: '/for-you'
      },
        'For you'
      ),
      tag(AppSidebarLink, {
        href: '/following'
      },
        'Following'
      ),
      tag(AppSidebarLink, {
        href: '/popular'
      },
        'Popular'
      ),
      tag(AppSidebarLink, {
        href: userProfilePostsHref(user)
      },
        'Your Bookmarks'
      ),
      tag(AppSidebarLink, {
        href: sharedHref()
      },
        'Your Inbox',
        inboxCount > 0 && (
          tag('span', {
            className: bem.element('inbox-count')
          },
            inboxCount
          )
        )
      ),
      tag('div', {
        className: bem.element('heading', 'interests')
      },
        'Your Interests'
      ),
      user.interests.map(interest => (
        tag(AppSidebarLink, {
          key: `interest:${interest.key}`,
          href: interestProfilePostsHref(interest)
        },
          interest.name
        )
      ))
    )
  )
}

module.exports = AppSidebar
